<form [formGroup]="form" class="form" (ngSubmit)="onSubmit()" *ngIf="form">
  <div class="form-body">

    <div class="form-section">
      <h2 class="h5">{{ 'FORMS.BRANCH.BASIC_INFO.BASIC_INFO_TITLE' | translate }}</h2>

      <app-form-row [label]="'FORMS.BRANCH.BASIC_INFO.NAME' | translateControl : form | async">
        <app-input [type]="'text'" [mainForm]="form" [controlName]="'name'">
        </app-input>
      </app-form-row>

      <app-form-row [label]="'FORMS.BRANCH.BASIC_INFO.NAME2' | translateControl : form | async">
        <app-input [type]="'text'" [mainForm]="form" [controlName]="'name2'">
        </app-input>
      </app-form-row>

      <app-form-row [label]="'FORMS.BRANCH.BASIC_INFO.LOGO' | translateControl : form | async">
        <app-input-file [mainForm]="form" [controlName]="'photo'" [imageSrc]="branchLogo"
          [defaultImageSrc]="defaultImageSrc" [resourceType]="'Branch'" [layoutMod]="['square']"
          [buttonText]="'SETTINGS.BRANCH.UPLOAD_PHOTO'">
        </app-input-file>
      </app-form-row>

      <app-form-row
        [label]="['FORMS.ADDRESS.STREET_NAME', 'FORMS.ADDRESS.STREET_NR'] | translateControl : addressForm | async">
        <div class="row">
          <div class="col-8">
            <app-input [type]="'text'" [mainForm]="addressForm" [controlName]="'streetName'">
            </app-input>
          </div>
          <div class="col-4">
            <app-input [type]="'text'" [mainForm]="addressForm" [controlName]="'streetNr'">
            </app-input>
          </div>
        </div>
      </app-form-row>

      <app-form-row
        [label]="['FORMS.ADDRESS.ZIP_CODE', 'FORMS.ADDRESS.CITY', 'FORMS.ADDRESS.COUNTRY'] | translateControl : addressForm | async">
        <div class="row">
          <div class="col-3">
            <app-input [type]="'text'" [mainForm]="addressForm" [controlName]="'zipCode'">
            </app-input>
          </div>
          <div class="col-5">
            <app-input [type]="'text'" [mainForm]="addressForm" [controlName]="'city'">
            </app-input>
          </div>
          <div class="col-4">
            <app-dropdown [options]="dropdownData.countries" [labelKey]="'title'" [valueKey]="'value'"
              [mainForm]="addressForm" [controlName]="'country'" [searchable]="true" [defaultValue]="dropdownData.countries[0].value">
            </app-dropdown>
          </div>
        </div>
      </app-form-row>
    </div>

  </div>

  <div class="form-footer" *ngIf="!isModal && branch.id">
    <div class="d-flex justify-content-end">
      <button class="btn btn_primary" type="submit" [disabled]="!canSubmit">
        {{ 'GENERAL.SAVE' | translate }}
      </button>
    </div>
  </div>

</form>
